import { useRef } from 'react'

import { Button } from '@tribeplatform/react-ui-kit/Button'
import { Modal } from '@tribeplatform/react-ui-kit/Modal'

import { Form } from '../../Form/index.js'
import type { FormMethods } from '../../Form/index.js'
import { T } from '../../i18n/components/T.js'
import { useI18n } from '../../i18n/providers/I18nProvider.js'
import { MenuItem } from '../extensions/slash-menu/items.js'

export const EmbedFormDialog = ({
  onSubmit,
  onClose,
  open,
  embedItem,
}: {
  open?: boolean
  onSubmit: (data: { link: string }, methods: FormMethods) => void
  onClose?: () => void
  embedItem?: MenuItem
}) => {
  const { $t } = useI18n()

  const inputRef = useRef<HTMLInputElement>()
  return (
    <Modal open={open} onClose={onClose} initialFocus={inputRef}>
      <Modal.Header
        title={
          <span className="flex items-center">
            {embedItem?.icon && (
              <span className="flex items-center w-8 h-8 me-2">
                {embedItem.icon}
              </span>
            )}
            <T
              id="Composer.EmbedFormDialog.HeaderTitle"
              defaultMessage="Add {embed_item_name}"
              values={{ embed_item_name: embedItem?.label || 'Embed' }}
            />
          </span>
        }
        description={embedItem?.description}
      />
      <Modal.Content>
        <Form onSubmit={onSubmit}>
          <Form.Layout>
            <Form.Input
              ref={inputRef}
              name="link"
              autoComplete="href"
              label={$t({
                id: 'Generics.Link.Noun',
                defaultMessage: 'Link',
              })}
              validation={{
                required: $t({
                  id: 'Composer.EmbedFormDialog.LinkRequiredValidationMessage',
                  defaultMessage: 'Please add a valid link',
                }),
              }}
            />
            <Form.Actions>
              <Button type="submit" variant="primary">
                <T id="Generics.Add" defaultMessage="Add" />
              </Button>
              <Button variant="secondaryNeutral" onClick={onClose}>
                <T id="Generics.Cancel" defaultMessage="Cancel" />
              </Button>
            </Form.Actions>
          </Form.Layout>
        </Form>
      </Modal.Content>
    </Modal>
  )
}
